import { RefreshCw, WifiOff } from "lucide-react";

/**
 * Una lettura che non e riuscita, raccontata a chi guarda.
 *
 * Nasce da un difetto visto in console su staging: quando una chiamata falliva, a schermo
 * finiva il messaggio tecnico del browser, "Failed to fetch", in rosso e senza contesto.
 * Dice tre cose che quel messaggio non diceva: **che cosa** non si e potuto caricare, che il
 * dato probabilmente c'e lo stesso, e **come riprovare**.
 *
 * Prende il posto dello stato vuoto, e non gli si affianca: "non c'e niente" e "non sono
 * riuscito a leggere" sono due frasi diverse, e la seconda non va mai detta con la prima.
 * Un elenco vuoto per errore di rete e piu insidioso di un messaggio brutto, perche sembra
 * una risposta.
 */
export function ErrorState({
  cosa,
  dettaglio,
  onRiprova,
}: {
  /** Che cosa non si e potuto caricare, in italiano: "le segnalazioni", "le email". */
  cosa: string;
  /** Il messaggio tecnico vero: utile a chi mantiene il prodotto, non a chi guarda. */
  dettaglio?: string | null;
  onRiprova?: () => void;
}) {
  return (
    <div className="error-state" role="status">
      <WifiOff size={26} aria-hidden="true" />
      <div className="error-state__testo">
        <p className="error-state__titolo">Non e stato possibile caricare {cosa}.</p>
        <p className="error-state__nota">
          Quasi sempre e la connessione, o il programma che si sta aggiornando. I dati non sono
          andati persi: riprova fra un momento.
        </p>
        {dettaglio && (
          <details className="error-state__dettaglio">
            <summary>Dettaglio tecnico</summary>
            <code>{dettaglio}</code>
          </details>
        )}
      </div>
      {onRiprova && (
        <button type="button" className="button button--outline button--small" onClick={onRiprova}>
          <RefreshCw size={15} aria-hidden="true" /> Riprova
        </button>
      )}
    </div>
  );
}
